import { BIModel } from './BIModel';

export class BuyBrandPersonalizeBIModel extends BIModel {
  static eventName = 'buy_brand_personalize';

  #flow;
  #brands;
  #count;

  constructor(userId, flow, brands, count) {
    super(BuyBrandPersonalizeBIModel.eventName, userId);
    this.#flow = flow;
    this.#brands = brands;
    this.#count = count;
  }

  get flow() {
    return this.#flow;
  }

  get brands() {
    return this.#brands;
  }

  get count() {
    return this.#count;
  }

  get modelData() {
    return {
      flow: this.flow,
      brands: this.brands,
      count: this.count
    };
  }

}